import type { OrderSource } from "./useKitchenTickets";

export function pad2(n: number): string {
  return String(n).padStart(2, "0");
}

export function fmtAge(secondsIn: number): string {
  const seconds = Math.max(0, Math.floor(secondsIn));
  const hours = Math.floor(seconds / 3600);
  if (hours >= 24) return `${Math.floor(hours / 24)}d ${hours % 24}h`;
  if (hours) return `${hours}h ${Math.floor(seconds / 60) % 60}m`;
  return `${pad2(Math.floor(seconds / 60))}:${pad2(seconds % 60)}`;
}

/** "Mon 26 Oct" when the ticket was made before today, in this display's time zone. */
export function earlierDay(createdAt: string, now: Date): string | null {
  const made = new Date(createdAt);
  if (made.toDateString() === now.toDateString()) return null;
  return made.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short" }).replace(",", "");
}

export function ageSeconds(createdAt: string, now: Date): number {
  return (now.getTime() - new Date(createdAt).getTime()) / 1000;
}

const CHANNEL_LABELS: Record<OrderSource, string> = {
  pos: "POS",
  guest_portal: "Guest App",
  mobile_app: "Mobile App",
  phone: "Phone",
  walk_in: "Walk-in",
};

export function channelLabel(source: OrderSource): string {
  return CHANNEL_LABELS[source] ?? source;
}

export function formatClock(now: Date): { time: string; sec: string; ap: string } {
  let hours = now.getHours();
  const ap = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return { time: `${hours}:${pad2(now.getMinutes())}`, sec: pad2(now.getSeconds()), ap };
}

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function formatDateLabel(now: Date): string {
  return `${WEEKDAYS[now.getDay()]} · ${MONTHS[now.getMonth()]} ${now.getDate()}`;
}
